import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // 세션을 로컬 스토리지에 저장 (새로고침해도 유지)
    storage: localStorage,
    // 자동 새로고침 토큰 갱신
    autoRefreshToken: true,
    // 세션 지속성 유지
    persistSession: true,
    // 세션 만료 시 자동 로그아웃 방지
    detectSessionInUrl: true,
    // 크로스 디바이스를 위한 storage key 설정
    storageKey: 'sb-clozet-auth-token',
    // PKCE 플로우 (OAuth 소셜 로그인용)
    flowType: 'pkce'
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web'
    }
  }
});